export const generateAppConfig = () => {
  let exportResult = {
    appRepoLocation: "https://sg-app.heritagekapas.com.my",
    backendUrl: "http://localhost:3100",
    agentBackendUrl: "http://localhost:4230",
    jsReportUrl: "http://localhost:5488",
  };
  if (process.env.REACT_APP_PRODUCTION_MODE === "TEST") {
    exportResult.appRepoLocation = "https://sg-app.heritagekapas.com.my";
    exportResult.backendUrl = "https://sg-api.heritagekapas.com.my/admin";
    exportResult.agentBackendUrl =
      "https://sg-api.heritagekapas.com.my/business";
    exportResult.userPortalBackendUrl =
      "https://sg-api.heritagekapas.com.my/app";
    exportResult.jsReportUrl = "https://sg-report.heritagekapas.com.my";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "STAGE") {
    exportResult.appRepoLocation = "https://app.travoxis.com";
    exportResult.backendUrl = "https://admin-api.travoxis.com";
    exportResult.agentBackendUrl = "https://business-api.travoxis.com";
    exportResult.userPortalBackendUrl = "https://app-api.travoxis.com";
    exportResult.jsReportUrl = "https://report-test.summerbayresort.com.my";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "PROD") {
    exportResult.appRepoLocation = "https://app.heritagekapas.com.my";
    exportResult.backendUrl = "https://api.heritagekapas.com.my/admin";
    exportResult.agentBackendUrl =
      "https://api.heritagekapas.com.my/business";
    exportResult.userPortalBackendUrl =
      "https://api.heritagekapas.com.my/app";
    exportResult.jsReportUrl = "https://report.heritagekapas.com.my";
  }
  return exportResult;
};
